import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

type PlayTagProps = {
  label: string;
};

const Tag = styled("span")(({ theme }: { theme: Theme }) => ({
  padding: "4px 11px",
  borderRadius: 7,
  fontSize: 11,
  fontWeight: 500,
  background: "#EBF4FF",
  color: theme.palette.brand.blueAccent,
}));

const PlayTag: FC<PlayTagProps> = ({ label }) => <Tag>{label}</Tag>;

export default PlayTag;
